export enum BTW {
    Exempt,
    Compulsory,
    CompulsorySmallCompany,
    MixedCompulsory,
    MixedCompulsorySmallCompany
}

export enum Sector {
    Medical,
    LiberalProfession,
    Education,
    Insurance,
    Horeca,
    Construction,
    Waste,
    Consulting,
    Retail,
    Other
}

export enum ActivityType {
    Therapeutic,
    notFullyTherapeutic,
}

export enum NonExemptTurnOver {
    MoreThan25k,
    LessThan25k
}

export enum TurnOver {
    MoreThan25k,
    LessThan25k
}